import React from "react";
import {
  Phone,
  Mail,
  MapPin,
  Clock3,
  Send,
} from "lucide-react";

import "../public css/Contact.css";

const Contact = () => {
  return (
    <div className="billing-contact">

      {/* ================= HERO ================= */}

      <section className="contact-hero">
        <div className="contact-hero-content">

          <span className="section-label">
            CONTACT US
          </span>

          <h1>
            Let's talk about
            <span> your business.</span>
          </h1>

          <p>
            Have questions about Dectwin? Our team is here
            to help you simplify billing and manage your
            business more efficiently.
          </p>

        </div>
      </section>


      {/* ================= CONTACT SECTION ================= */}

      <section className="contact-section">

        <div className="contact-container">

          {/* ================= LEFT INFO ================= */}

          <div className="contact-info">

            <span className="section-label">
              GET IN TOUCH
            </span>

            <h2>
              We're here to
              <br />
              help you.
            </h2>

            <p className="contact-description">
              Whether you need help getting started, have a
              question about billing, or want to learn more
              about Dectwin, feel free to reach out.
            </p>


            <div className="contact-info-item">

              <div className="contact-icon">
                <Phone size={20} />
              </div>

              <div>
                <span>Phone</span>
                <strong>+91 8707510135</strong>
              </div>

            </div>


      

            <div className="contact-info-item">

              <div className="contact-icon">
                <Mail size={20} />
              </div>

              <div>
                <span>Email</span>
                <strong>dectwin@gmail.com</strong>
              </div>

            </div>


          

            <div className="contact-info-item">

              <div className="contact-icon">
                <MapPin size={20} />
              </div>

              <div>
                <span>Address</span>
                <strong>
                85/47, CY Chintamani Rd, Darbhanga Colony,
               George Town, Prayagraj, Uttar Pradesh 211002</strong>
              </div>

            </div>


            {/* BUSINESS HOURS */}

            <div className="contact-info-item">

              <div className="contact-icon">
                <Clock3 size={20} />
              </div>

              <div>
                <span>Business Hours</span>
                <strong>
                  Mon - Sat, 9:00 AM - 6:00 PM
                </strong>
              </div>

            </div>

          </div>



          <div className="contact-form-card">

            <div className="form-heading">

              <h3>
                Send us a message
              </h3>

              <p>
                Fill out the form and we'll get back to you
                as soon as possible.
              </p>

            </div>


            <form>

         

              <div className="contact-form-row">

                <div className="contact-form-group">

                  <label>
                    Your Name
                  </label>

                  <input
                    type="text"
                    placeholder="Enter your name"
                  />

                </div>


                <div className="contact-form-group">

                  <label>
                    Email Address
                  </label>

                  <input
                    type="email"
                    placeholder="Enter your email"
                  />

                </div>

              </div>


      

              <div className="contact-form-row">

                <div className="contact-form-group">

                  <label>
                    Phone Number
                  </label>

                  <input
                    type="tel"
                    placeholder="Enter phone number"
                  />

                </div>


                <div className="contact-form-group">

                  <label>
                    Subject
                  </label>

                  <input
                    type="text"
                    placeholder="How can we help?"
                  />

                </div>

              </div>


              {/* MESSAGE */}

              <div className="contact-form-group">

                <label>
                  Message
                </label>

                <textarea
                  rows="5"
                  placeholder="Tell us how we can help..."
                ></textarea>

              </div>



              <button
                type="submit"
                className="contact-submit-btn"
              >
                Send Message
                <Send size={17} />
              </button>

            </form>

          </div>

        </div>

      </section>


   
      {/* <section className="contact-cta">

        <div className="contact-cta-content">

          <span className="section-label">
            GET STARTED
          </span>

          <h2>
            Ready to simplify
            <br />
            your billing?
          </h2>

          <p>
            Start managing your invoices, inventory and
            customers with Dectwin today.
          </p>

        </div>

      </section> */}
{/* <section className="contact-map-section container-fluid p-0 m-0">

  <div className="map-fullscreen p-0 m-0">

    <iframe
      title="Dectwin Services Location"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14410.77426621421!2d81.85919791194186!3d25.44850641644149!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398555df0e636aa3%3A0x85a9c468f03b08a2!2sDectwin%20services!5e0!3m2!1sen!2sin!4v1787391355344!5m2!1sen!2sin"
      allowFullScreen
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
    ></iframe>

  </div>

</section> */}
{/* <section className="contact-map-section container-fluid px-0">

  <div className="map-fullscreen">

    <iframe
      title="Dectwin Services Location"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14410.77426621421!2d81.85919791194186!3d25.44850641644149!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398555df0e636aa3%3A0x85a9c468f03b08a2!2sDectwin%20services!5e0!3m2!1sen!2sin!4v1787391355344!5m2!1sen!2sin"
      allowFullScreen
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
    ></iframe>

  </div>

</section> */}
<section className="contact-map-section container-fluid">

  <div className="map-fullscreen">

    <iframe
      title="Dectwin Services Location"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14410.77426621421!2d81.85919791194186!3d25.44850641644149!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398555df0e636aa3%3A0x85a9c468f03b08a2!2sDectwin%20services!5e0!3m2!1sen!2sin!4v1787391355344!5m2!1sen!2sin"
      allowFullScreen
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
    ></iframe>

  </div>

</section>
    </div>
  );
};

export default Contact;